import { ca } from '@cian/analytics';

import { CAROUSEL_PLACE } from '../../../../constants';

export function trackOfferClick({
  realtyUserId,
  position,
  offerId,
  cardUrl,
  title,
}: {
  realtyUserId: number;
  position: number;
  offerId: number;
  cardUrl: string;
  title: string;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_card',
    page: {
      extra: {
        is_specproject: true,
        to_object: offerId,
        object_type: 'offer',
        position: position + 1,
        hit_url: cardUrl,
        carousel_name: title,
        carousel_place: CAROUSEL_PLACE,
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
